import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import useDashboardContext from 'contexts/dashboard.context';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { ENUM_WORK_MODES } from 'utils/enum';
import { handleApiError } from 'utils/functions';

type ChangeWorkModeModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ChangeWorkModeModal = ({ isOpen, onClose }: ChangeWorkModeModalProps) => {
  const { activeCompany } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const currentWorkModes = activeCompany.work_modes || [];
  const [workModes, setWorkModes] = useState<ENUM_WORK_MODES[]>(activeCompany.work_modes || []);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await apiService.put('company/update', {
        data: { work_modes: workModes, company_id: activeCompany.id }
      });
      toast(<ToastMessage type='success' message='Work mode updated successfully' />);
      onClose();
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const changeWorkMode = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    if (checked) {
      setWorkModes([...workModes, name as ENUM_WORK_MODES]);
    } else {
      setWorkModes([...workModes.filter((mode) => mode !== name)]);
    }
  };

  const disabled =
    currentWorkModes.length === workModes.length &&
    currentWorkModes.every((mode) => new Set(workModes).has(mode));
  return (
    <LocalModal title='Change work mode' isOpen={isOpen} onRequestClose={onClose}>
      <div className='my-8'>
        <div className='border-b border-gray-19 py-4'>
          <Input
            name={ENUM_WORK_MODES.REMOTE}
            type='checkbox'
            label='Remote'
            checked={workModes.includes(ENUM_WORK_MODES.REMOTE)}
            onChange={changeWorkMode}
          />
        </div>
        <div className='border-b border-gray-19 py-4'>
          <Input
            name={ENUM_WORK_MODES.ONSITE}
            type='checkbox'
            label='Onsite'
            checked={workModes.includes(ENUM_WORK_MODES.ONSITE)}
            onChange={changeWorkMode}
          />
        </div>
      </div>
      <div className='flex justify-end'>
        <Button
          variant='block'
          color='primary'
          onClick={handleConfirm}
          className='w-[139px] h-[41px] text-sm'
          loading={loading}
          disabled={disabled}>
          Confirm
        </Button>
      </div>
    </LocalModal>
  );
};

export default ChangeWorkModeModal;
